export const checkoutUrl = 'https://100mappe.impultienda.ar'

export const brand = {
  eyebrow: 'Pour les coachs sportifs et les entraîneurs en salle de sport',
  headline: '100 exercices déjà analysés.',
  headlineAccent: 'Fini de chercher des explications dans des vidéos et des manuels.',
  name: 'Atlas Visuel de Biomécanique',
  subheadline: '100 Fiches Visuelles + 6 Bonus Pratiques',
  description:
    "Muscles sollicités, plans anatomiques, exécution correcte, erreurs fréquentes et variantes : tout est organisé en fiches visuelles prêtes à consulter quand vous en avez besoin.",
  tagline: "Choisissez. Ouvrez. Expliquez avec plus d'assurance.",
}

export const heroCta = "Je veux l'Atlas complet"

export const heroNote = 'Accès immédiat · PDF imprimables · Paiement unique'

export const heroGuarantee = 'Garantie de remboursement de 7 jours.'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '100', label: 'Fiches Visuelles' },
  { value: '100', label: 'Exercices Analysés' },
  { value: '3', label: "Catégories d'Entraînement" },
  { value: '6', label: 'Bonus Pratiques' },
]

export interface Situation {
  title: string
  text: string
}

export const situationsTitle = 'Vous vous reconnaissez dans ces situations ?'

export const situationsIntro =
  'Si vous travaillez comme coach sportif, au moins une de ces situations vous est probablement familière.'

export const situations: Situation[] = [
  {
    title: "Un client vous pose une question d'anatomie.",
    text: "Vous connaissez l'exercice, mais expliquer clairement quels muscles travaillent n'est pas toujours évident.",
  },
  {
    title: "Vous repérez une erreur technique, mais vous avez du mal à l'expliquer.",
    text: 'Vous aimeriez avoir un support clair pour mieux comprendre le mouvement et les corrections possibles.',
  },
  {
    title: 'Vous perdez du temps entre vidéos, livres et notes.',
    text: 'Chaque fois que vous voulez vérifier un exercice, vous devez chercher des informations dans plusieurs sources.',
  },
  {
    title: 'Vous connaissez la théorie, mais la mettre en pratique prend du temps.',
    text: "Faire le lien entre les muscles, les plans anatomiques et les exercices réels n'est pas toujours simple.",
  },
]

export const situationsClosing =
  "Ce n'est pas votre formation qui manque. C'est un système visuel à consulter quand vous en avez besoin."

export const comparisonCopy = {
  title: "Passez d'informations éparpillées à 100 exercices déjà organisés.",
  oldEyebrow: 'Avant',
  oldLabel: "Sans l'Atlas",
  atlasEyebrow: 'Après',
  atlasLabel: "Avec l'Atlas Visuel",
  closing: 'Moins de recherches. Plus de temps à consacrer à vos clients.',
}

export const comparisonOld: string[] = [
  'Vous cherchez des explications dans différentes vidéos et différents manuels.',
  'Vos notes sur les muscles et les mouvements sont dispersées.',
  'Vous perdez du temps à retrouver les mêmes informations.',
  'Vous devez faire vous-même le lien entre la théorie et les exercices.',
]

export const comparisonAtlas: string[] = [
  '100 exercices déjà analysés et organisés.',
  'Muscles, technique et mouvements réunis sur une même fiche.',
  'Erreurs fréquentes et variantes faciles à consulter.',
  'Anatomie directement reliée aux exercices réels.',
]

export interface DemoStep {
  number: string
  title: string
  text: string
}

export const demoCopy = {
  title: "Un client vous pose une question. Vous avez déjà l'analyse sous la main.",
  questionLabel: 'Un client vous demande :',
  question: 'Quels muscles je travaille quand je fais un squat ?',
}

export const demoSteps: DemoStep[] = [
  {
    number: '01',
    title: 'Choisissez',
    text: 'Ouvrez la section Bas du corps et retrouvez la fiche du squat.',
  },
  {
    number: '02',
    title: 'Consultez',
    text: 'Revoyez les muscles sollicités, la bonne exécution et les erreurs les plus fréquentes.',
  },
  {
    number: '03',
    title: 'Expliquez',
    text: "Appuyez-vous sur l'analyse pour donner une explication plus claire à votre client.",
  },
]

export const galleryCopy = {
  title: "Découvrez les fiches de l'intérieur.",
  subtitle:
    'De vrais exercices analysés visuellement, avec toutes les informations essentielles déjà organisées.',
  footer: '100 exercices analysés. Un seul système prêt à consulter.',
  cta: 'Je veux les 100 fiches visuelles',
}

export interface GalleryItem {
  title: string
  caption: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    title: 'Squat libre',
    caption:
      'Muscles principaux, stabilisateurs, plan anatomique et erreurs fréquentes : tout est réuni sur une seule fiche.',
    image:
      'https://cdn.magicpatterns.com/uploads/ccTL7LGi5E2ADNYoe69PqD/Captura_de_pantalla_2026-10-15_a_la(s)_11.09.43_p._m..png',
  },
  {
    title: 'Fente bulgare',
    caption: 'Travail unilatéral : ce qui se stabilise, ce qui compense et comment corriger.',
    image:
      'https://cdn.magicpatterns.com/uploads/45vjRojLxqAQVKzHKpPHrN/Captura_de_pantalla_2026-10-15_a_la(s)_11.10.02_p._m..png',
  },
  {
    title: 'Développé incliné',
    caption:
      'Faisceau claviculaire du grand pectoral, coiffe des rotateurs et trajectoire correcte de la barre.',
    image:
      'https://cdn.magicpatterns.com/uploads/goqUAFNxx7EbdKaLi9dbus/Captura_de_pantalla_2026-10-15_a_la(s)_11.10.31_p._m..png',
  },
  {
    title: 'Crossover',
    caption:
      'Adduction horizontale dans le plan transversal et contrôle de la tension sur les pectoraux.',
    image:
      'https://cdn.magicpatterns.com/uploads/bePf5CbWiLsap14BRbuoEG/Captura_de_pantalla_2026-10-15_a_la(s)_11.10.55_p._m..png',
  },
  {
    title: 'Rowing barre',
    caption: "Rétraction scapulaire, chaîne postérieure et pourquoi l'élan ruine l'exercice.",
    image:
      'https://cdn.magicpatterns.com/uploads/xv1MarX1dxnkyZ7dbQ8ToW/Captura_de_pantalla_2026-10-15_a_la(s)_11.11.20_p._m..png',
  },
]

export const systemCopy = {
  title: '100 exercices déjà analysés pour vous.',
  subtitle: "Un système visuel complet, organisé en trois grandes catégories d'entraînement.",
  includesTitle: 'Sur chaque fiche, vous retrouvez :',
  closing:
    "Bien plus qu'un simple ebook d'anatomie. Un support visuel pour comprendre et expliquer les exercices.",
}

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  description: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Bas du corps',
    detail: '40 Fiches Visuelles',
    summary:
      'Squat, soulevé de terre, hip thrust, fentes, presse à cuisses et principales variantes.',
    description:
      'Muscles sollicités, technique et erreurs fréquentes pour les principaux exercices du bas du corps.',
    spine: 'bg-blue-400',
  },
  {
    number: '02',
    title: 'Haut du corps',
    detail: '40 Fiches Visuelles',
    summary:
      "Développé couché, pompes, tractions, rowing, tirage vertical et exercices d'isolation.",
    description: 'Des analyses visuelles des principaux mouvements de poussée et de tirage.',
    spine: 'bg-blue-600',
  },
  {
    number: '03',
    title: 'Sangle abdominale et stabilisation',
    detail: '20 Fiches Visuelles',
    summary: 'Gainage, dead bug, bird dog, anti-rotation et contrôle lombo-pelvien.',
    description: 'Stabilisation, muscles sollicités et détails du mouvement.',
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  'Muscles principaux et secondaires',
  'Muscles stabilisateurs',
  'Plans anatomiques et chaînes cinétiques',
  'Exécution correcte',
  'Erreurs fréquentes et corrections possibles',
  'Variantes et conseils pratiques',
]

export interface Bonus {
  tag: string
  title: string
  benefit: string
}

export const bonusesCopy = {
  title: 'En plus, vous recevez 6 Bonus Pratiques.',
  subtitle: 'Des outils complémentaires pour analyser, réviser et expliquer les exercices.',
  badge: 'Inclus',
  closing: 'Les 6 bonus sont déjà inclus dans votre Atlas.',
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bonus 01',
    title: 'Guide Anti-Blocage',
    benefit: 'Des schémas pratiques pour expliquer les exercices de façon claire et structurée.',
  },
  {
    tag: 'Bonus 02',
    title: 'Parcours de 7 Jours',
    benefit: "Un parcours organisé pour consolider l'analyse des exercices.",
  },
  {
    tag: 'Bonus 03',
    title: 'Planning de Révision',
    benefit: 'Des schémas de révision sur 7 jours, 3 jours et 24 heures.',
  },
  {
    tag: 'Bonus 04',
    title: 'Check-list des 60 Secondes',
    benefit: 'Une séquence rapide pour analyser chaque exercice avec méthode.',
  },
  {
    tag: 'Bonus 05',
    title: 'Cahier Pratique',
    benefit: "20 exercices avec des exemples d'analyse et d'explication.",
  },
  {
    tag: 'Bonus 06',
    title: 'Dictionnaire Express',
    benefit: 'Muscles, mouvements et plans anatomiques expliqués simplement.',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city?: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'GR',
    quote:
      "Je connaissais déjà beaucoup de notions, mais j'avais du mal à les relier aux exercices. Les voir expliquées visuellement m'a aidée à bien mieux comprendre ce qui se passe pendant chaque mouvement.",
    author: 'Giulia R.',
    role: 'Étudiante en STAPS',
  },
  {
    initials: 'ML',
    quote:
      "Je l'utilise surtout quand je veux revoir rapidement un exercice. J'apprécie de retrouver tout de suite les muscles sollicités, le mouvement et les erreurs fréquentes sans fouiller dans mille notes.",
    author: 'Marco L.',
    role: 'Coach sportif',
  },
  {
    initials: 'EF',
    quote:
      "J'avais peu de temps pour réviser avant l'examen et les fiches m'ont aidée à mettre de l'ordre. Certains sujets qui me semblaient confus dans les livres sont devenus beaucoup plus clairs.",
    author: 'Elisa F.',
    role: 'Étudiante',
  },
]

export const guaranteeCopy = {
  title: 'Garantie de 7 jours. Achetez en toute tranquillité.',
  paragraphs: [
    'Consultez les fiches et découvrez les ressources incluses.',
    "Si, dans les 7 jours suivant votre achat, vous estimez que l'Atlas ne correspond pas à vos besoins, vous pouvez demander un remboursement conformément aux conditions de la garantie.",
  ],
  closing: 'Un seul paiement. Aucun abonnement. Accès à vie.',
}

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: 'Est-ce adapté aux coachs sportifs qui débutent ?',
    answer:
      "Oui. Les fiches vous aident à faire le lien entre l'anatomie et les exercices réels. Elles peuvent servir de support pendant votre préparation professionnelle et lorsque vous avez besoin de revoir un mouvement.",
  },
  {
    question: "Puis-je consulter l'Atlas sur mon téléphone pendant mes séances ?",
    answer:
      'Oui. Tous les documents sont au format PDF. Vous pouvez les consulter depuis votre téléphone, votre tablette ou votre ordinateur, selon vos besoins.',
  },
  {
    question: "Contient-il des programmes d'entraînement déjà prêts ?",
    answer:
      "Non. C'est un système d'analyse visuelle des exercices, pas un recueil de programmes d'entraînement personnalisés.",
  },
  {
    question: 'Puis-je imprimer les fiches ?',
    answer:
      "Oui. Les fiches sont fournies au format PDF imprimable. Vous pouvez les consulter à l'écran ou les imprimer pour les garder à portée de main.",
  },
  {
    question: "Comment vais-je recevoir l'Atlas ? Dois-je payer chaque mois ?",
    answer:
      "Après votre paiement, vous obtenez immédiatement accès aux documents numériques. Il s'agit d'un paiement unique, sans abonnement ni frais mensuels. Les fichiers sont à vous, avec un accès à vie.",
  },
  {
    question: 'Que se passe-t-il si je ne suis pas satisfait ?',
    answer:
      "Vous bénéficiez d'une garantie de remboursement de 7 jours. Si l'Atlas ne correspond pas à vos besoins, vous pouvez demander un remboursement pendant cette période, conformément aux conditions de la garantie.",
  },
]

export interface Offer {
  title: string
  name: string
  summary: string
  includes: string[]
  price: string
  currency: string
  cta: string
  note: string
}

export const offer: Offer = {
  title: 'Votre Atlas Visuel complet. Tout en un seul achat.',
  name: 'Atlas Visuel de Biomécanique',
  summary: '100 Fiches Visuelles + 6 Bonus Pratiques',
  includes: [
    '100 exercices déjà analysés',
    '40 fiches Bas du corps',
    '40 fiches Haut du corps',
    '20 fiches Sangle abdominale et stabilisation',
    'Muscles, technique, erreurs et variantes',
    'Les 6 bonus inclus',
    'PDF imprimables',
    'Accès immédiat et à vie',
  ],
  price: '19',
  currency: '€',
  cta: "Oui, je veux l'Atlas complet",
  note: 'Paiement unique · Aucun abonnement · Garantie de 7 jours',
}

export const finalCtaCopy = {
  title: '100 exercices déjà analysés. Prêts quand vous en avez besoin.',
  subtitle:
    'Fini de chercher les mêmes explications. Gardez muscles, technique, erreurs fréquentes et variantes organisés dans un seul Atlas Visuel.',
  summary: '100 Fiches Visuelles + 6 Bonus',
  cta: "Je veux l'Atlas complet",
}

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/kkiAtcjeuYZf8vNuNrwRJd/mockup-fr.png'
